document.addEventListener("DOMContentLoaded", function () {
  const videos = document.querySelectorAll(".video-section__media video");

  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.25 // start loading when 25% visible
  };

  const loadVideo = (video) => {
    if (video.dataset.loaded) return; // prevent double-loading

    const sourceDesktop = document.createElement("source");
    sourceDesktop.src = video.dataset.srcDesktop;
    sourceDesktop.type = "video/mp4";
    sourceDesktop.media = "(min-width: 768px)";

    const sourceMobile = document.createElement("source");
    sourceMobile.src = video.dataset.srcMobile;
    sourceMobile.type = "video/mp4";
    sourceMobile.media = "(max-width: 767px)";

    video.appendChild(sourceDesktop);
    video.appendChild(sourceMobile);

    video.loop = true;
    video.autoplay = true;
    video.load();
    video.play().catch(() => {}); // prevent autoplay errors
    video.dataset.loaded = "true";
  };

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadVideo(entry.target);
        obs.unobserve(entry.target); // stop observing after loading
      }
    });
  }, options);

  videos.forEach(video => observer.observe(video));
});
